import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import { Turnstile } from '@marsidev/react-turnstile';
import "./ContactPage.css";

const ContactPage = () => {
  const { t } = useTranslation();
  const form = useRef();
  const [isSent, setIsSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!token) {
      alert("Vänligen vänta på att säkerhetskontrollen blir klar.");
      return;
    }

    const formData = new FormData(e.target);
    const botTrap = formData.get("website_url");

    if (botTrap) {
      console.warn("Bot detected and blocked.");
      setIsSent(true);
      return;
    }

    setLoading(true);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs
      .sendForm(
        serviceId,
        templateId,
        form.current,
        publicKey
      )
      .then(
        (result) => {
          console.log("Success:", result.text);
          setIsSent(true);
          setLoading(false);
          setToken(null);
          form.current.reset();
        },
        (error) => {
          console.error("Error details:", error);
          alert("Något gick fel, vänligen försök igen eller kontakta oss via telefon.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="mag-contact-page">
      <div className="mag-container">

        <header className="mag-list-header">
          <span className="mag-label">{t("contact")}</span>
          <h1 className="mag-list-title">{t("contactUs")}</h1>
          <p className="mag-list-intro">{t("contactHeroText")}</p>
        </header>

        <div className="mag-contact-grid">

          <section className="mag-contact-details-col">
            <div className="mag-contact-text-block">
              <h2 className="mag-contact-sub">{t("aboutUs")}</h2>
              <p className="mag-contact-desc">{t("aboutUsText")}</p>
            </div>

            <div className="mag-contact-methods">
              <div className="mag-contact-row">
                <span className="mag-row-label">{t("phone")}</span>
                <a href="tel:+46708240472">+46 708 24 04 72</a>
              </div>
              <div className="mag-contact-row">
                <span className="mag-row-label">{t("email")}</span>
                <a href="mailto:peter@dinmaklareahus.se">peter@dinmaklareahus.se</a>
              </div>
            </div>
          </section>

          <section className="mag-contact-form-col">
            {!isSent ? (
              <form ref={form} onSubmit={sendEmail} className="mag-editorial-form" style={{ position: 'relative' }}>

                {/* HONEYPOT*/}
                <div style={{
                  position: 'absolute',
                  opacity: 0,
                  zIndex: -1,
                  height: 0,
                  width: 0,
                  overflow: 'hidden',
                  pointerEvents: 'none'
                }}>
                  <input
                    type="text"
                    name="website_url"
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                <input type="hidden" name="form_subject" value="Allmän kontaktförfrågan" />
                <input type="hidden" name="property_type" value="" />
                <input type="hidden" name="time" value={new Date().toLocaleString('sv-SE')} />

                <div className="mag-form-row">
                  <label>{t("form.name")}</label>
                  <input
                    type="text"
                    name="user_name"
                    required
                    maxLength="70"
                  />
                </div>

                <div className="mag-form-row">
                  <label>{t("form.email")}</label>
                  <input
                    type="email"
                    name="user_email"
                    required
                  />
                </div>

                <div className="mag-form-row">
                  <label>{t("form.phone")}</label>
                  <input
                    type="tel"
                    name="user_phone"
                    maxLength="20"
                  />
                </div>

                <div className="mag-form-row">
                  <label>{t("message")}</label>
                  <textarea
                    name="message"
                    required
                    rows="4"
                    maxLength="2000"
                    placeholder={t("form.messagePlaceholder")}
                  />
                </div>

                <div>
                  <Turnstile
                    siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => setToken(token)}
                    options={{
                      appearance: 'always',
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="mag-form-btn"
                  disabled={loading}
                >
                  {loading ? t("form.sending") : t("sendRequest")}
                </button>
              </form>
            ) : (
              <div className="mag-success-message">
                <h2 className="mag-contact-sub">{t("thankYou")}</h2>
                <p className="mag-contact-desc">
                  {t("successText")}
                </p>
                <button
                  onClick={() => setIsSent(false)}
                  className="mag-form-btn"
                  style={{ marginTop: '20px' }}
                >
                  {t("backToForm")}
                </button>
              </div>
            )}
          </section>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;